<template>
  <div>
    <el-card>
      <div class="forms">
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <el-form-item label="视频标题">
            <!-- <el-input v-model="form.videoTitle"></el-input> -->
            <el-select v-model="form.videoTitle" clearable filterable>
              <el-option
                v-for="item in tableData"
                :label="item.videoTitle"
                :value="item.videoTitle"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称">
            <el-select v-model="form.productId" clearable>
              <el-option
                v-for="item in productSelectListData"
                :label="item.productName"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="btnBackgory" @click="searchData">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-popconfirm
              title="您确定要删除多条数据吗？"
              @confirm="deleteData"
            >
              <el-button class="white" slot="reference">删除</el-button>
            </el-popconfirm>
          </el-form-item>
          <el-form-item>
            <el-button class="btnBackgory" @click="addHomeData('dialogForm')"
              >新增安装视频</el-button
            >
          </el-form-item>
        </el-form>

        <el-table
          ref="table"
          v-loading="loading"
          :data="tableData"
          border
          tooltip-effect="dark"
          style="width: 100%; margin-top: 20px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column
            prop="categoryName"
            label="产品分类"
            min-width="140"
            align="center"
          />
          <el-table-column
            prop="productName"
            label="产品名称"
            min-width="80"
            align="center"
          />
          <el-table-column
            prop="videoTitle"
            label="视频标题"
            min-width="120"
            align="center"
          />
          <el-table-column
            prop="videoLink"
            label="视频"
            min-width="120"
            align="center"
          >
            <template #default="scope">
              <video
                style="width: 50px; height: 50px"
                :src="`${uploadUrl}+${scope.row.videoLink}`"
              ></video>
            </template>
          </el-table-column>

          <el-table-column
            prop="remark"
            label="备注"
            show-overflow-tooltip
            min-width="260"
            align="center"
          />
          <el-table-column label="操作" min-width="100" align="center">
            <template #default="scope">
              <div class="operate">
                <div class="btn" @click="edit(scope.row)">编辑</div>
                <el-popconfirm
                  title="您确认要删除该条数据吗？"
                  @confirm="deleteOnly(scope.row)"
                >
                  <div slot="reference" class="btn">删除</div>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageContainer">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageData.page"
            :page-sizes="[20, 40, 60, 80, 100]"
            :page-size="pageData.pageSize"
            layout="total, prev, pager, next,sizes"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>

    <el-dialog
      :title="`${title}安装视频`"
      :visible.sync="dialogVisible"
      width="750px"
      @close="cancelBtn('dialogForm')"
    >
      <!-- <div class="title">首页新增展图</div> -->
      <div class="forms">
        <el-form
          :model="dialogForm"
          :rules="dialogRules"
          ref="dialogForm"
          label-width="160px"
          class="demo-dialogForm"
          label-position="left"
        >
          <el-form-item label="产品分类" prop="categoryName">
            <el-select
              v-model="dialogForm.categoryName"
              @change="categorySelect"
              clearable
            >
              <el-option
                v-for="item in selectListData"
                :label="item.categoryName"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称" prop="productId">
            <el-select v-model="dialogForm.productId" clearable>
              <el-option
                v-for="item in productSelectListData"
                :label="item.productName"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="视频标题" prop="videoTitle">
            <el-input v-model="dialogForm.videoTitle"></el-input>
          </el-form-item>
          <el-form-item label="添加视频" prop="videoLink" ref="videoLinkUpload">
            <!-- 上传  accept=".mp4"-->
            <div style="display: flex">
              <el-upload
                v-if="uploadPercentage == 0 || uploadPercentage == 100"
                :action="`${upload}/file/uploadNew`"
                :show-file-list="false"
                :on-success="uploadSuccess"
                list-type="picture-card"
                :before-upload="beforeUpload"
                :on-error="handleError"
                :on-progress="handleUploadProgress"
              >
                <!-- <img v-if="videoLink" :src="videoLink" class="avatar" /> -->
                <video v-if="videoLink" :src="videoLink" class="avatar"></video>
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <el-progress
                v-else
                type="circle"
                :percentage="uploadPercentage"
                style="width: 98px; height: 98px"
              />
            </div>
          </el-form-item>
          <el-form-item label="备注信息">
            <el-input
              type="textarea"
              v-model="dialogForm.remark"
              placeholder="请输入备注内容"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item> -->
          <div class="footerBtn">
            <el-button class="dialogWhite" @click="cancelBtn('dialogForm')"
              >取 消</el-button
            >
            <el-button
              class="dialogBtnBackgory"
              @click="submitForm('dialogForm')"
              >确 定</el-button
            >
          </div>

          <!-- </el-form-item> -->
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
export default {
  name: "installServer",
  data() {
    return {
      form: {
        productId: "",
        videoTitle: ""
      },
      ids: [],
      title: "新增",
      selectListData: [],
      productSelectListData: [],
      loading: false,
      pageData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      dialogVisible: false,
      uploadUrl: "",
      upload: "",
      dialogForm: {
        categoryName: "",
        productId: "",
        videoTitle: "",
        // videoLink: "",
        remark: "",
        videoLink: ""
      },
      videoLoading: false,
      videoLink: "",
      dialogRules: {
        categoryName: [
          { required: true, message: "请选择区域", trigger: "change" }
        ],
        productId: [
          { required: true, message: "请输入产品名称", trigger: "blur" }
        ],
        videoTitle: [
          { required: true, message: "请输入视频标题", trigger: "blur" }
        ],
        videoLink: [{ required: true, message: "请选择视频" }]
      },
      uploadPercentage: 0
    };
  },
  mounted() {
    this.upload = apis.upload;
    this.uploadUrl = apis.uploadUrl;
    this.getSeleteDataList();

    this.getSearchList({ ...this.pageData });
  },
  methods: {
    // 获取 下拉 数据
    getSeleteDataList() {
      apis.productGetCategoryList().then(res => {
        if (res.code === 200) {
          this.selectListData = res.data;
        }
      });
      apis.getAllProduct().then(res => {
        if (res.code === 200) {
          this.productSelectListData = res.data;
        }
      });
    },
    // table 选中
    handleSelectionChange(val) {
      this.ids = val.map(item => item.id);
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 新增
    addHomeData(formName) {
      this.getSeleteDataList();
      this.dialogVisible = true;
      this.title = "新增";
      this.dialogForm = {};
      this.videoLink = "";
      this.$refs[formName]?.resetFields();
      this.uploadPercentage = 0;
    },
    beforeUpload() {
      this.$message({
        message: "上传视频中",
        type: "warning"
      });
    },
    uploadSuccess(res) {
      if (res.code === 200) {
        this.dialogForm.videoLink = res.data.id;
        this.videoLink = apis.uploadUrl + res.data.id;
        this.$refs["videoLinkUpload"].clearValidate();
        this.$message({
          message: "上传视频成功,显示较慢请稍等",
          type: "success"
        });
      }
    },
    handleError() {
      this.$message({
        message: "上传失败",
        type: "error"
      });
    },
    handleUploadProgress(event) {
      // 根据上传进度更新进度条的值
      this.uploadPercentage = Math.round((event.loaded / event.total) * 100);
    },
    // 获取 table 数据
    getSearchList(json) {
      this.loading = true;
      apis.installationDataList(json).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.total = res.total;
          this.loading = false;
        }
      });
    },
    // 搜索
    searchData() {
      const json = {
        ...this.pageData,
        ...this.form
      };
      this.getSearchList(json);
    },
    // 监听 分类 选择
    categorySelect(value) {
      const json = {
        categoryId: value,
        page: 1,
        pageSize: 200
      };
      apis.productList(json).then(res => {
        if (res.code === 200) {
          this.productSelectListData = res.data;
        }
      });
    },
    // 批量 删除
    deleteData() {
      if (this.ids.length) {
        apis.installationDeleteMap(this.ids).then(res => {
          if (res.code === 200) {
            this.getSearchList({ ...this.pageData });
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
        });
      }
    },
    // 确认 添加
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const json = {
            ...this.dialogForm
          };
          apis.installationAddAndEdit(json).then(res => {
            if (res.code === 200) {
              this.getSearchList({ ...this.pageData });
              this.dialogVisible = false;
              const msg = this.dialogForm.id ? "修改" : "新增";
              this.$message({
                message: `${msg}成功`,
                type: "success"
              });
              this.uploadPercentage = 0;
            }
          });
        }
      });
    },
    //dialog 取消按钮
    cancelBtn(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.uploadPercentage = 0;
    },
    // 编辑
    edit(row) {
      this.videoLink = apis.uploadUrl + row.videoLink;
      this.dialogForm = JSON.parse(
        JSON.stringify({
          id: row.id,
          categoryName: row.categoryName,
          productId: row.productId,
          videoTitle: row.videoTitle,
          videoLink: row.videoLink,
          remark: row.remark
        })
      );
      this.dialogVisible = true;
      this.title = "编辑";
    },
    // 删除一条
    deleteOnly(row) {
      apis.installationDeleteMap([row.id]).then(res => {
        if (res.code === 200) {
          this.getSearchList({ ...this.pageData });
          this.$message({
            message: "删除成功",
            type: "success"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-card {
  margin: 20px;
}
// // 1 解决 table 表头和内容错误
// ::v-deep .el-table {
//   th.gutter,
//   colgroup.gutter {
//     width: 0px !important;
//   }
// }
// // 2 关键css代码
// ::v-deep .el-table__header colgroup col[name="gutter"] {
//   display: table-cell !important;
// }
::v-deep .el-dialog__title {
  display: flex;
  align-items: center;
  font-size: 29px;
  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 29px;
    background-color: #008754;
    margin-right: 10px;
  }
}
.forms {
  .el-button--mini {
    margin-right: 20px;
  }
  .btnBackgory {
    width: 181px;
    height: 54px;
    background-color: #008754;
    color: white;
  }
  .white {
    width: 181px;
    height: 54px;
  }
  .backgoryWhite {
    width: 181px;
    height: 54px;
  }
  .btnBorderColor {
    width: 181px;
    height: 54px;
    color: #008754;
    border-color: #008754;
  }
  ::v-deep .el-form {
    .left {
      .el-input--mini .el-input__inner {
        width: 295px;
      }
    }
    .footerBtn {
      text-align: right;
      .dialogWhite {
        width: 145px;
        height: 54px;
      }
      .dialogBtnBackgory {
        width: 145px;
        height: 54px;
        background-color: #008754;
        color: white;
      }
    }
  }
  ::v-deep .el-upload {
    width: 178px;
    height: 178px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  ::v-deep .el-upload:hover {
    border-color: #409eff;
  }
  ::v-deep .el-upload--picture-card {
    line-height: 178px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
.pageContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.aHref {
  color: #5e92ff;
}
.operate {
  display: flex;
  justify-content: space-around;
  .btn {
    color: #729fff;
  }
}
::v-deep .el-dialog {
  .el-form {
    .el-input {
      width: 770px;
    }
    .el-textarea__inner {
      width: 770px;
    }
  }
}
::v-deep .el-progress-circle {
  width: 178px !important;
  height: 178px !important;
}
</style>
